import type {Pointer} from '@wix/document-services-types'
import {ConversionDalNamespaces} from '../constants'
import type {ConversionCompRef} from '../../types'

export const getStructurePointer = ({id}: Pick<ConversionCompRef, 'id'>): ConversionCompRef => ({
    id,
    type: ConversionDalNamespaces.structure
})
export const getVirtualStructurePointer = ({
    id
}: Pick<ConversionCompRef, 'id'>): ConversionCompRef<ConversionDalNamespaces.virtualStructure> => ({
    id,
    type: ConversionDalNamespaces.virtualStructure
})
export const getMeasurementsPointer = ({id}: Pick<Pointer, 'id'>) => ({id, type: ConversionDalNamespaces.measurements})
export const getSourceLayoutPointer = ({id}: Pick<Pointer, 'id'>) => ({id, type: ConversionDalNamespaces.sourceLayout})
export const getTargetLayoutPointer = ({id}: Pick<Pointer, 'id'>) => ({id, type: ConversionDalNamespaces.targetLayout})
export const getTransformationsPointer = ({id}: Pick<Pointer, 'id'>) => ({
    id,
    type: ConversionDalNamespaces.transformations
})
export const getStylePointer = ({id}: Pick<Pointer, 'id'>) => ({id, type: ConversionDalNamespaces.style})
export const getResolvedStylePointer = ({id}: Pick<Pointer, 'id'>) => ({
    id,
    type: ConversionDalNamespaces.resolvedStyle
})
export const getInnerElementPointer = ({id}: Pick<Pointer, 'id'>) => ({
    id,
    type: ConversionDalNamespaces.innerElements
})
